import { render } from "./DetailRoom.vue?vue&type=template&id=b1d46078"
import script from "./DetailRoom.vue?vue&type=script&lang=js"
export * from "./DetailRoom.vue?vue&type=script&lang=js"

import exportComponent from "/Users/teguhsangra/Web/web_servio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__